import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import React from "react";
import {color, radius, shadow} from "common/tokens";

// Declared before the variants so a variant's border wins over the button reset.
const useStyles = makeStyles({
  base: {
    background: color.SURFACE,
    boxSizing: 'border-box',
  },
  interactive: {
    cursor: 'pointer',
  },
  // Aside panels — roster, leaderboard, walkthrough.
  card: {
    borderRadius: radius.CARD,
    boxShadow: shadow.PANEL,
  },
  // Session cards: bordered, clips the banner image.
  media: {
    borderRadius: radius.MEDIA_CARD,
    border: `1px solid ${color.CARD_BORDER}`,
    boxShadow: shadow.CARD,
    overflow: 'hidden',
  },
  // Hero panels — next mentoring call.
  panel: {
    borderRadius: radius.PANEL,
    boxShadow: shadow.PANEL,
  },
  bordered: {
    border: `1px solid ${color.CARD_BORDER}`,
  },
});

// Clickable cards are a div with a button role rather than a <button>, so they
// can still contain their own action button without nesting one inside another.
const Card = ({variant = 'card', bordered = false, className, children, onClick, ...rest}) => {
  const classes = useStyles();

  const keyActivate = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? keyActivate : undefined}
      className={classNames(
        classes.base,
        onClick && classes.interactive,
        classes[variant],
        bordered && classes.bordered,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;
